import React from 'react'

interface Props {
  label: string
  value: string
  onChange: (e: React.SyntheticEvent) => void
}

export const ProjectBinaryAttribute = ({ label, value, onChange }: Props) => {
  return <div>
    <div className='label'>
      {label}
    </div>
    <div className='value'>
      <select value={value} onChange={onChange}>
        <option value={'null'}>Choose a value</option>
        <option value={'true'}>Yes</option>
        <option value={'false'}>No</option>
      </select>
    </div>
  </div>
}
